import {inject, injectable} from "inversify";
import KODivisionPromotionEvaluator from "@/modules/competitions/services/evaluators/KODivisionPromotionEvaluator";
import {Matchday} from "@/modules/competitions/entity";
import {EventEmitter} from "@/modules/base/events";
import {BeforeMatchdayEvaluation} from "@/modules/competitions/events/BeforeMatchdayEvaluation";
import {AfterMatchdayEvaluation} from "@/modules/competitions/events/AfterMatchdayEvaluation";
import {nonblocking} from "@/utils";
import type {MatchEvaluatorInterface} from "@/modules/competitions/interfaces";
import {BeforeMatchEvent} from "@/modules/match/events/BeforeMatchEvent";
import {AfterMatchEvent} from "@/modules/match/events/AfterMatchEvent";
import {Application} from "@/di";
import SkillBasedMatchEvaluator from "@/modules/competitions/services/evaluators/SkillBasedMatchEvaluator";
import {initializeApp} from "firebase/app";
import {getPerformance, trace} from "firebase/performance";
import MemoryLogger from "@/modules/base/services/MemoryLogger";

@injectable()
export default class MatchdayEvaluator {
  constructor(
    @inject(Application) protected app: Application,
    @inject(SkillBasedMatchEvaluator) protected matchEvaluator: MatchEvaluatorInterface,
    @inject(KODivisionPromotionEvaluator) protected koDivisionPromotionEvaluator: KODivisionPromotionEvaluator,
    @inject(EventEmitter) private em: EventEmitter,
    @inject(MemoryLogger) private memoryLogger: MemoryLogger,
  ) {
  }

  async evaluate(matchday: Matchday): Promise<void> {

    // const firebase = initializeApp({
    //   apiKey: "AIzaSyABbSQVPMuhKatN7TP7VBuB-MSYGxkrASc",
    //   authDomain: "footy-95765353.firebaseapp.com",
    //   projectId: "footy-95765353",
    //   storageBucket: "footy-95765353.appspot.com",
    //   messagingSenderId: "789264624943",
    //   appId: "1:789264624943:web:5a99ae8908714e08de85da"
    // });
    // const perf = getPerformance(firebase);
    // const t  = trace(perf, 'matchevaluator');
    // // @ts-ignore
    // t.putAttribute('memory_before', (window.performance.memory.usedJSHeapSize / window.performance.memory.jsHeapSizeLimit).toString())
    // t.start();

    this.memoryLogger.log('match-evaluator::before');

    await this.em.emitAsync(new BeforeMatchdayEvaluation(matchday));

    console.time('MatchdayEvaluator::loading');
    matchday = await Matchday
      .createQueryBuilder('matchday')
      .innerJoinAndSelect('matchday.division', 'division')
      .innerJoinAndSelect('division.competition', 'competition')
      .innerJoinAndSelect('matchday.matches', 'match')
      .leftJoinAndSelect('matchday.next', 'next')

      .innerJoinAndSelect('match.matchday', 'mMatchday')
      .innerJoinAndSelect('mMatchday.division', 'mDivision')
      .innerJoinAndSelect('mDivision.competition', 'mCompetition')

      .innerJoinAndSelect('match.homeTeam', 'homeTeam')
      .innerJoinAndSelect('match.awayTeam', 'awayTeam')
      .leftJoinAndSelect('match.connectedMatch', 'connectedMatch')
      .leftJoinAndSelect('homeTeam.players', 'homeTeamPlayer')
      .leftJoinAndSelect('awayTeam.players', 'awayTeamPlayer')
      .leftJoinAndSelect('homeTeamPlayer.country', 'homeTeamPlayerCountry')
      .leftJoinAndSelect('awayTeamPlayer.country', 'awayTeamPlayerCountry')
      .leftJoinAndSelect('homeTeamPlayer.suspensions', 'homeTeamPlayerSuspensions')
      .leftJoinAndSelect('awayTeamPlayer.suspensions', 'awayTeamPlayerSuspensions')

      .leftJoinAndSelect('match.stadiumLog', 'stadiumLog')
      .leftJoinAndSelect('stadiumLog.terraceLogs', 'terraceLog')

      .where('matchday.id = :id', {id: matchday.id})
      .andWhere('match.result IS NULL')
      .getOneOrFail();
    console.timeEnd('MatchdayEvaluator::loading');

    for (const match of matchday.matches) {
      await this.em.emitAsync(new BeforeMatchEvent(match, matchday.division.competition));

      console.time('MatchdayEvaluator::matchEvaluation');
      if (!match.homeTeam.user && !match.awayTeam.user) {
        await nonblocking(async () => await this.matchEvaluator.evaluate(match));
      }
      console.timeEnd('MatchdayEvaluator::matchEvaluation');

      await this.em.emitAsync(new AfterMatchEvent(match, matchday.division.competition));
    }

    this.memoryLogger.log('match-evaluator::middle');
    // // @ts-ignore
    // t.putAttribute('memory_after', (window.performance.memory.usedJSHeapSize / window.performance.memory.jsHeapSizeLimit).toString())
    // t.stop();

    matchday.finished = true;
    matchday.current = false;
    await matchday.save();

    const unfinishedMatchdaysCount = await Matchday.createQueryBuilder('matchday')
      .innerJoin('matchday.season', 'season')
      .innerJoin('matchday.division', 'division')
      .where('division.id = :id', matchday.division)
      .andWhere('season.current = true')
      .andWhere('matchday.finished = false')
      .getCount();

    matchday.division.finished = unfinishedMatchdaysCount === 0;
    await matchday.division.save();

    // todo next is not bound in league and doesnt seems to work
    if (matchday.next) {
      matchday.next.current = true;
      await matchday.next.save();
    }

    await this.em.emitAsync(new AfterMatchdayEvaluation(matchday));

    this.memoryLogger.log('match-evaluator::after');
  }
}